import DataFieldOptions from './DataFieldOptions'
import { DATA_FIELD_TYPES, isMultipleType } from '../../../helpers/dataFields/dataFieldTypes'

/**
 * De soort van een gegevens-item, en bij een meerkeuzeveld de antwoordopties.
 *
 * Losgetrokken uit `DataModalContent` zodat de gegevenstabel van een huishouden
 * hetzelfde blok toont in plaats van een tweede kopie ervan — twee kopieën lopen
 * uiteen, en dan biedt hetzelfde veldtype op twee schermen andere keuzes.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 * AI-CONTEXT: See docs/features/gegevensveld-types.md
 *
 * @param {object} props
 * @param {string} props.type - Huidig veldtype
 * @param {(type: string) => void} props.setType - Krijgt het gekozen veldtype
 * @param {Array<{docid: string, Option: string}>} [props.dataOptions] - Antwoordopties, op volgorde
 * @param {() => void} props.addOption - Voegt een lege antwoordoptie toe
 * @param {(docid: string, value: string) => void} props.onChangeOption - Hernoemt een optie
 * @param {(docid: string) => void} props.onDeleteOption - Verwijdert een optie
 * @param {(items: Array<object>) => void} [props.onReorderOptions] - Krijgt de nieuwe volgorde
 * @param {boolean} [props.canEdit] - Of de gebruiker mag aanpassen
 * @returns {JSX.Element}
 */
const DataFieldTypeAndOptions = ({
  type,
  setType,
  dataOptions = [],
  addOption,
  onChangeOption,
  onDeleteOption,
  onReorderOptions,
  canEdit = true,
}) => (
  <>
    <h3>Type</h3>
    <p>Kies het type van het gegevens item</p>
    {/* De kop erboven is een <h3> en geen label, dus zonder dit heeft de
        keuzelijst geen naam — niet voor een schermlezer en niet in een test. */}
    <select
      aria-label="Type van het gegeven"
      onChange={(e) => setType(e.target.options[e.target.selectedIndex].value)}
      value={type || ''}
      disabled={!canEdit}
    >
      <option value="">-- Selecteer --</option>
      {DATA_FIELD_TYPES.map((veldType) => (
        <option key={veldType.value} value={veldType.value}>{veldType.label}</option>
      ))}
    </select>

    {isMultipleType(type) && (
      <DataFieldOptions
        options={dataOptions}
        addOption={addOption}
        onChangeOption={onChangeOption}
        onDeleteOption={onDeleteOption}
        onReorderOptions={onReorderOptions}
        canEdit={canEdit}
      />
    )}
  </>
)

export default DataFieldTypeAndOptions
